import React from "react";
import { ConselhosProvider } from "./context/conselhos-context";
import { Conselhos } from "./conselhos";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const ConselhosFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Conselhos"}>
            <ConselhosProvider>
                <Conselhos />
            </ConselhosProvider>
        </BaseInternalFormFactory>
    );
};

export default ConselhosFactory;
